import * as _ from "lodash"
import {Measure, Dimension} from "@/cube"
import {MetricSliced} from "@/cube/metric-data/MetricStore"

export function toPercent<T extends Measure>(
  metricData: MetricSliced<T>,
  filter: {[key in Dimension]?: unknown}
): number {
  const total = _.sumBy(metricData.end, metricData.metric)
  const filtered = _.sumBy(_.filter(metricData.end, filter), metricData.metric)

  return filtered / total
}
